import { createReducer, on } from "@ngrx/store";
import { ComunicadoOutputDto } from "src/app/domain/DTOs/output/comunicado.output.dto";
import { EstruturaRetornoDadosPaginadosOutputDto } from "src/app/domain/DTOs/output/estrutura-retorno-dados-paginados.output.dto";
import { listarComunicados, listarComunicadosSuccess, listarComunicadosFailure, listarComunicadosFinish } from "../actions/listar-comunicados.action";

export interface ListarComunicadosState {
  response: EstruturaRetornoDadosPaginadosOutputDto<ComunicadoOutputDto[]> | null;
  error: string[] | null;
}

export const initialState: ListarComunicadosState = {
  response: null,
  error: null,
};

export const ListarComunicadosReducer = createReducer(
  initialState,
  on(listarComunicados, state => ({ ...state, error: null })),
  on(listarComunicadosSuccess, (state, { response }) => ({ ...state, response, error: null })),
  on(listarComunicadosFailure, (state, { response }) => ({ ...state, response: null, error: response.erros })),
  on(listarComunicadosFinish, state => ({ ...state, response: null, error: null }))
);